export default "__VITE_ASSET__DiJ8fsVy__"